import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import { BackupAction } from "../types/actions";
import { Backup } from "../types/backup";

const getAllBackups = (): AppThunk<() => void> => (dispatch) => {
    const unsubscribe = firebase
        .firestore()
        .collection("backups")
        .onSnapshot((querySnapshot) => {
            const backups: Backup[] = [];
            querySnapshot.forEach((doc: firebase.firestore.DocumentData) => {
                backups.push(doc.data());
            });
            dispatch({
                type: BackupAction.SET_BACKUPS,
                backups,
            });
        });

    return unsubscribe;
};

export default getAllBackups;
